import { Suspense } from 'react';
import { Outlet, useParams } from 'react-router-dom';
import { DashboardDataProvider } from 'shared/contexts/DashboardDataContext';
import { useApi } from 'shared/hooks/useApi';
import { usePreview } from 'shared/hooks/usePreview';
import { useRealtimer } from 'shared/hooks/useRealtimer';
import { MeetingType } from 'types/Meeting/MeetingType';
import { mapDtoToMeetingType } from 'types/Meeting/mapper';
import { Navbar } from './components/Navbar';
import { PageSkeleton } from './components/PageSkeleton';
import { UpcomingMeeting } from './components/UpcomingMeeting';

export const AuthenticatedLayout = () => {
  const { dashboardId } = useParams();
  const { previewToken } = usePreview();
  const { data: upcomingMeeting, refetch } = useApi<MeetingType>('upcoming-meeting', {
    mapFn: mapDtoToMeetingType,
  });
  useRealtimer(`ClientDashboardMeetingUpdated-${dashboardId}`, () => {
    refetch();
  });

  return (
    <DashboardDataProvider key={`${dashboardId}:${previewToken ?? ''}`}>
      <div className="bg-background min-h-dvh pt-[95px] md:pt-[51px]">
        <Navbar />
        <main className="max-w-container mx-auto p-4 pt-6 md:p-6 lg:px-8 lg:pb-12">
          {upcomingMeeting && (
            <div className="mb-6">
              <UpcomingMeeting {...upcomingMeeting} />
            </div>
          )}
          <Suspense fallback={<PageSkeleton />}>
            <Outlet />
          </Suspense>
        </main>
      </div>
    </DashboardDataProvider>
  );
};
